/**
 * @file コンポーネント：フル動画ページタイムライントピック ロジック管理
 */

// ライブラリ読み込み
import React, { useState } from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const TimelineTopic = (props) => {
    /**
     * コンテンツ開閉状態
     */
    const [isOpen, setIsOpen] = useState(false);

    return <Presenter {...props} isOpen={isOpen} setIsOpen={setIsOpen} />;
};
